/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, withAssign } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import { pairUpdateNoBufferEvent } from '@root/entities/realtime'

import type { PairModel } from '@root/entities/pair'

type PairMetadataFields = {
  priceNative: BigNumber
  priceUsd: BigNumber
  marketCapUsd: BigNumber
  updatedAt: Date
}

export const reatomPairMetadataModel = (pair: PairModel) => {
  const latestSocketDataAtom = atom<PairMetadataFields | undefined>(undefined)
  const metadataFromPairModelAtom = atom((ctx): PairMetadataFields => {
    const updatedAt = ctx.spy(pair.updatedAt)
    const price = ctx.spy(pair.price)
    const marketCapUsd = ctx.spy(pair.marketCapUsd)
    return {
      priceNative: price.priceNative,
      priceUsd: price.priceUsd,
      marketCapUsd: marketCapUsd,
      updatedAt: updatedAt,
    }
  })

  const metadataAtom = atom((ctx) => {
    const metadataFromPairModel = ctx.spy(metadataFromPairModelAtom)
    const socketData = ctx.spy(latestSocketDataAtom)
    if (socketData && socketData.updatedAt > metadataFromPairModel.updatedAt) {
      return socketData
    }
    return metadataFromPairModel
  })

  const initializeAction = action(() => {
    const unsub = pairUpdateNoBufferEvent.onCall((ctx, data) => {
      if (data.poolAddress !== pair.address) {
        return
      }
      latestSocketDataAtom(ctx, {
        priceNative: BigNumber(data.priceNative),
        priceUsd: BigNumber(data.priceUsd),
        marketCapUsd: BigNumber(data.marketCapUsd),
        updatedAt: new Date(data.updatedAt),
      })
    })

    return () => {
      unsub()
    }
  })

  return metadataAtom.pipe(
    withAssign(() => ({
      initialize: initializeAction,
    })),
  )
}
